const bookmarkIcon = `
    <svg class="bookmark-svg" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M22.5 5H9.5C8.67157 5 8 5.67157 8 6.5V25.3787C8 26.715 9.61571 27.3843 10.5607 26.4393L14.9393 22.0607C15.5251 21.4749 16.4749 21.4749 17.0607 22.0607L21.4393 26.4393C22.3843 27.3843 24 26.715 24 25.3787V6.5C24 5.67157 23.3284 5 22.5 5Z" stroke-width="1.5"/>
    </svg>
`;

export default bookmarkIcon;
